import { render, staticRenderFns } from "./register-basic.vue?vue&type=template&id=748771dc&scoped=true&"
import script from "./register-basic.vue?vue&type=script&lang=js&"
export * from "./register-basic.vue?vue&type=script&lang=js&"
import style0 from "./register-basic.vue?vue&type=style&index=0&id=748771dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748771dc",
  null
  
)

export default component.exports